import { Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';

import { StepMock } from '../../../interfaces/mock.interface';
import { Step } from './step';

@Injectable({
    providedIn: 'root',
})
export class CartStep extends Step {
    public static readonly key: string = 'cart';
    public ecommerceStep: string = 'Panier';
    public isValid: boolean;
    public label: string = 'Récapitulatif';
    public next: Step;
    public previous: Step = null;
    public routerLink: string = '/panier';
    public hasReminder = false;
    public stepMocks: StepMock[] = [
        {
            url: '/ventes/controle-portabilite',
            mocks: [
                {
                    key: 'check_porta_ok',
                    label: 'Controle de portabilité ok',
                    default: true,
                    data: {
                        statut: true,
                        message: 'La demande de portabilité peut être enregistrée.',
                    },
                },
            ],
        },
    ];

    constructor() {
        super();
        this._isLoaded.next(true);
    }

    public canAccess(): Observable<boolean> {
        return of(true);
    }

    public canDisplay(): boolean {
        return true;
    }
}
